import esES from 'antd/lib/locale-provider/es_ES';

/* ANT DESIGN */
const antdConfig = {
  locale: esES,
};

export { antdConfig };
